module.exports = __webpack_public_path__ + "static/img/nanjuese.6c1c716.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/nanjuese.png
// module id = OEZw
// module chunks = 1